type RegisterClickParams = {
  source: string;
  linkText?: string;
  href?: string;
};

export function trackRegisterClick({ source, linkText, href }: RegisterClickParams) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") {
    return;
  }

  window.gtag("event", "register_click", {
    source,
    link_text: linkText ?? "",
    link_url: href ?? "",
    page_path: window.location.pathname,
  });
}
